import { TCocktailDetailProps } from "@/components/pages/cocktail/type";
import { CocktailDetailsMaster } from "../master";

export function CocktailDetailsSmirnoff(props: TCocktailDetailProps) {
    return <CocktailDetailsMaster {...props} />
}